/**
 * Gateway API
 * Gateway API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from '@angular/common/http';

import {Observable} from 'rxjs';

import {Role} from '../model/role';
import {RoleDTO} from '../model/roleDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class GatewayRoleResourceService {

    protected basePath = 'https://dmp.airiane.com/services/gateway';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param roleName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _delete(roleName: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public _delete(roleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public _delete(roleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public _delete(roleName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (roleName === null || roleName === undefined) {
            throw new Error('Required parameter roleName was null or undefined when calling _delete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<any>('delete', `${this.basePath}/api/role/${encodeURIComponent(String(roleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllRolesAndRules(observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: Array<string>; }>;
    public getAllRolesAndRules(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: Array<string>; }>>;
    public getAllRolesAndRules(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: Array<string>; }>>;
    public getAllRolesAndRules(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<{ [key: string]: Array<string>; }>('get', `${this.basePath}/api/roles-by-rules`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param roleName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRole(roleName: string, observe?: 'body', reportProgress?: boolean): Observable<RoleDTO>;
    public getRole(roleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDTO>>;
    public getRole(roleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDTO>>;
    public getRole(roleName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (roleName === null || roleName === undefined) {
            throw new Error('Required parameter roleName was null or undefined when calling getRole.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<RoleDTO>('get', `${this.basePath}/api/role/${encodeURIComponent(String(roleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoles(observe?: 'body', reportProgress?: boolean): Observable<Array<RoleDTO>>;
    public getRoles(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RoleDTO>>>;
    public getRoles(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RoleDTO>>>;
    public getRoles(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<Array<RoleDTO>>('get', `${this.basePath}/api/role/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRules(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getRules(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getRules(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getRules(observe: any = 'body', reportProgress = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/api/rule/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param roleName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRulesByRole(roleName: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getRulesByRole(roleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getRulesByRole(roleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getRulesByRole(roleName: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (roleName === null || roleName === undefined) {
            throw new Error('Required parameter roleName was null or undefined when calling getRulesByRole.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.request<Array<string>>('get', `${this.basePath}/api/role/${encodeURIComponent(String(roleName))}/rules`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveRole(body: Role, observe?: 'body', reportProgress?: boolean): Observable<RoleDTO>;
    public saveRole(body: Role, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDTO>>;
    public saveRole(body: Role, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDTO>>;
    public saveRole(body: Role, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling saveRole.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleDTO>('post', `${this.basePath}/api/role/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
